import { faCog } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, ButtonProps } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import styles from './ButtonSettings.module.scss'

export const ButtonSettings = (props: ButtonProps) => {
  const { t } = useTranslation()
  return (
    <Button
      {...props}
      variant="primary"
      className={classNames(
        styles.root,
        'negative-primary d-flex align-items-center'
      )}
    >
      <FontAwesomeIcon icon={faCog} className="mr-1" />
      {t('administration.courses.new.form.notifications.config.button')}
    </Button>
  )
}
